var map = {
	"./arrow.svg": 82573,
	"./close.svg": 95210,
	"./search-clear.svg": 60622,
	"./search.svg": 78038,
	"./sticky-top.svg": 25021,
	"./word-deco.svg": 29048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22627;